import * as React from "react";
import IMDSensorConnectForm from "../../../components/Forms/IMDSensor/ConnectForm";

export default function ConnectSensors() {
  return <IMDSensorConnectForm />;
}
